import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { BuildingOfficeIcon } from "@heroicons/react/24/outline";
import { useDispatch } from "react-redux";
import * as reportsServices from "../../../services/reports.services";
import { logout } from "../../../slices/authSlice";
import ApexCharts from "apexcharts";
import PageLoader from "../../Loaders/PageLoader";

const Institutes = () => {
  const [pricings, setPricings] = useState(null);
  const [loading, setLoading] = useState(false);

  const { t } = useTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    setLoading(true);
    const getPricing = async () => {
      await reportsServices
        .getInstitutesPricings()
        .then((response) => {
          let pricesArray = [];
          let subscription = [];
          let institutesPiricingsId = [];
          response.data.prices.forEach((pricing) => {
            pricesArray.push(pricing?.price);
            subscription.push(pricing?.subscriptions);
            institutesPiricingsId.push(pricing?.priceId);
          });
          setPricings(pricesArray);
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          if (error.response.responseCode === 401) {
            dispatch(logout());
          }
        });
    };
    getPricing();
    // eslint-disable-next-line
  }, [dispatch]);

  const getinstituteChartOptions = () => {
    var options = {
      series: pricings,
      chart: {
        width: 380,
        type: "donut",
      },
      labels: pricings,
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200,
            },
            legend: {
              position: "bottom",
            },
          },
        },
      ],
      colors: ["rgb(162, 28, 175)", "rgb(29, 78, 216)", "rgb(190, 18, 60)"],
    };
    return options;
  };

  useEffect(() => {
    if (!loading && pricings) {
      let element = document.getElementById("institutes_pricing");

      let options = getinstituteChartOptions();
      let chart = new ApexCharts(element, options);
      chart.render();
      return function cleanUp() {
        chart.destroy();
      };
    }
    // eslint-disable-next-line
  }, [loading, pricings]);

  return (
    <div>
      <div className="rounded-tr-lg rounded-br-lg relative bg-white p-6 focus-within:ring-2 focus-within:ring-inset focus-within:ring-blue-500">
        <div className="flex flex-row">
          <span className="text-purple-700 bg-rose-50 rounded-lg inline-flex p-3 ring-4 ring-white">
            <BuildingOfficeIcon className="h-6 w-6" aria-hidden="true" />
          </span>
          <h3 className="text-lg font-medium mt-3 mx-2">
            <Link to={"#"} className="focus:outline-none">
              <span className="absolute inset-0" aria-hidden="true" />
              {t("institutesPricings")}
            </Link>
          </h3>
        </div>
        <div className="mt-6 flex justify-center items-center">
          {loading && <PageLoader />}
          <div id="institutes_pricing"></div>
        </div>
      </div>
    </div>
  );
};

export default Institutes;
